(function () {
  if (window.__fsUpsellBound) return;
  window.__fsUpsellBound = true;
  var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
  var MAX = 12;

  // Add-to-cart from any upsell card (delegated)
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fs-upsell-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'fs-upsell', data: { source: 'fs-upsell' } }
        }));
      })
      .catch(function (err) { console.error(err); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  // Arrow navigation (delegated)
  document.addEventListener('click', function (e) {
    var nav = e.target && e.target.closest ? e.target.closest('[data-fs-prev],[data-fs-next]') : null;
    if (!nav) return;
    var car = nav.closest('[data-fs-upsell-carousel]');
    if (!car) return;
    fsMove(car, nav.hasAttribute('data-fs-next') ? 1 : -1);
  });

  function fsMove(car, dir) {
    var cards = car.querySelectorAll('.fs-card');
    if (!cards.length) return;
    var i = parseInt(car.getAttribute('data-index') || '0', 10) + dir;
    if (i < 0) i = cards.length - 1;
    if (i >= cards.length) i = 0;
    car.setAttribute('data-index', i);
    var track = car.querySelector('[data-fs-track]');
    if (track) track.style.transform = 'translateX(' + (-i * 100) + '%)';
  }

  // Recommendations return price in cents (number); storefront JSON returns a dollar string.
  function toCents(price) { return typeof price === 'number' ? price : Math.round(parseFloat(price) * 100); }
  function fsMoney(cents) { return '$' + (Number(cents) / 100).toFixed(2); }
  function fsImg(p) {
    if (p.featured_image && typeof p.featured_image === 'string') return p.featured_image;
    if (p.images && p.images[0]) return p.images[0].src || p.images[0];
    return '';
  }
  function fsEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fsPopulate() {
    var car = document.querySelector('[data-fs-upsell-carousel]');
    if (!car || car.getAttribute('data-loaded') === '1') return;
    var seed = car.getAttribute('data-seed-id');
    if (!seed) return;
    car.setAttribute('data-loaded', '1');

    var recUrl = '/recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&limit=10&intent=related';
    Promise.all([
      fetch(recUrl).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }),
      fetch('/collections/all/products.json?limit=30').then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }),
      fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
    ]).then(function (res) {
      var rec = (res[0] && res[0].products) || [];
      var coll = (res[1] && res[1].products) || [];
      var cart = res[2] || { items: [] };
      var inCart = {};
      (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });

      var track = car.querySelector('[data-fs-track]');
      if (!track) return;
      track.innerHTML = '';
      var seen = {};
      var n = 0;
      var pool = rec.concat(coll);

      for (var j = 0; j < pool.length && n < MAX; j++) {
        var p = pool[j];
        if (!p || seen[p.id] || inCart[p.id]) continue;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v) continue;
        seen[p.id] = true;
        var img = fsImg(p);
        var card = document.createElement('div');
        card.className = 'fs-card';
        card.innerHTML =
          (img ? '<img class="fs-card__img" src="' + fsEsc(img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          '<div class="fs-card__info">' +
            '<p class="fs-card__title">' + fsEsc(p.title) + '</p>' +
            '<p class="fs-card__price">' + fsMoney(toCents(v.price)) + '</p>' +
          '</div>' +
          '<button type="button" class="fs-card__add" data-fs-upsell-add data-variant-id="' + v.id + '">Add</button>';
        track.appendChild(card);
        n++;
      }

      if (n === 0) { car.setAttribute('hidden', ''); return; }
      car.setAttribute('data-index', '0');
      track.style.transform = 'translateX(0)';
      car.removeAttribute('hidden');
      var arrows = car.querySelectorAll('.fs-carousel__arrow');
      for (var k = 0; k < arrows.length; k++) arrows[k].style.display = n > 1 ? '' : 'none';
    }).catch(function (err) { console.error(err); car.setAttribute('hidden', ''); });
  }

  var fsTimer;
  function fsSchedule() { clearTimeout(fsTimer); fsTimer = setTimeout(fsPopulate, 120); }

  if (document.readyState !== 'loading') fsPopulate();
  document.addEventListener('DOMContentLoaded', fsPopulate);
  document.addEventListener('cart:update', fsSchedule);
  new MutationObserver(fsSchedule).observe(document.documentElement, { childList: true, subtree: true });
})();
